import styled from 'styled-components'
import _ from 'lodash'
import InfiniteScroll from 'react-infinite-scroller'

import useTranslate from 'hooks/useTranslate'
import useMounted from 'hooks/useMounted'
import media from '../config/theme/media'

import H3 from 'components/Typography/H3'
import P from 'components/Typography/P'
import Link from 'components/Link'
import Loader from 'components/Loader'
import { useResourceCategories } from '../hooks/resourceHooks'

const CategoryList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding-left: 0;
  width: 100%;
  max-width: 100%;
  h2 {
    margin-bottom: 0;
  }
`
const CategoryListItem = styled.li`
  margin: 0.5em 0;
  font-weight: normal;
  line-height: 16px;
  font-size: 12px;
  ${media.greaterThan('md')`
    font-size: 16px;
    line-height: 24px;
  `}
`
const CategoryLink = styled(Link)`
  display: flex;
  h2 {
    color: #1d70b8;
    text-decoration: underline;
    margin-top: 0;
    margin-bottom: 5px;
    display:inline-block;
  }
  span {
    display:inline-block;
    margin-left: 5px;
  }
`
const LoadingMessage = styled(P)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
`
const StyledInfiniteScroll = styled(InfiniteScroll)`
  width: 100%;
`
const StyledDescription = styled(P)`
  margin-top: 0;
  ${media.greaterThan('md')`
    margin-top: 5px;
  `}
`
const ResourceCategories = () => {
  const translate = useTranslate()
  const resourceCategories = useResourceCategories()
  const [isMounted] = useMounted()
  return (
    <>
      {isMounted ? (
        <StyledInfiniteScroll
          initialLoad={false}
          loader={
            <LoadingMessage className='loader' key={0}>
              {translate('RESOURCES_LIST_LOADING')}
            </LoadingMessage>
          }
        >
          <CategoryList>
            {_.map(resourceCategories, (item) => {
              return (
                <CategoryListItem key={item.urlName}>
                  <H3 as='H2'>
                    <CategoryLink href={`/resources/${item.urlName}`}>
                      {item.categoryName}
                    </CategoryLink>
                  </H3>
                  <StyledDescription>{item.shortDescription}</StyledDescription>
                </CategoryListItem>
              )
            })}
          </CategoryList>
        </StyledInfiniteScroll>
      ) : (
        <Loader />
      )}
    </>
  )
}

export default ResourceCategories
